import {CircularProgress} from "@material-ui/core";
import axios from "axios";
import MUIDataTable from "mui-datatables";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import AdminLayout from "./AdminLayout";
import {Dialog, Slide, AppBar, Toolbar} from "@material-ui/core";
import {Link, useNavigate} from "react-router-dom";
import CustomMuiDataTable from "src/Components/CustomMuiDataTable";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const AdminContactUsMessages = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState("");
  const columns = [
    {
      name: "id",
      label: "ID",
    },
    {
      name: "fullName",
      label: "Full Name",
    },
    {
      name: "email",
      label: "Email",
    },
    {
      name: "phone",
      label: "Phone",
    },

    {
      name: "message",
      label: "Message",
    },

    {
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, meta) => {
          return (
            <div>
              <button
                className="btn btn-primary mx-1"
                onClick={() => {
                  viewReport(meta);
                }}
              >
                View
              </button>

              <button
                className="btn btn-danger mx-1"
                onClick={() => {
                  deleteForm(meta);
                }}
              >
                Delete
              </button>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    filter: true,
    rowsPerPage: 50,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: "none",
    textLabels: {
      body: {
        noMatch: isLoading ? <CircularProgress /> : "There is no matching data to display",
      },
    },
  };

  const handleClose = () => {
    setVisible(false);
  };

  const openVendorProfile = (id, name) => {
    navigate(`/vendor/${name}`, {state: {id: id}});
  };

  const getData = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API}/admin/contactus-messages/get`)
      .then(function (response) {
        setData(response.data);

        setIsLoading(false);
      })
      .catch(function (error) {
        setIsLoading(false);
        toast("Error", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(error);
      });
  };

  const deleteForm = (meta) => {
    const id = meta.rowData[0];
    Swal.fire({
      title: "Please Confirm Your Action ?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      icon: "warning",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios({
          method: "post",
          url: `${process.env.REACT_APP_API}/admin/contactus-messages/delete`,
          data: {id: id},
        })
          .then((response) => {
            toast.success(`Success`);
            getData();
          })
          .catch((error) => {
            toast.error(`Error`);
          });
      }
    });
  };

  const viewReport = (meta) => {
    const id = meta.rowData[0];
    let dataSelected = data.filter((record) => record.id == id);
    setSelectedData(dataSelected[0]);

    setVisible(!visible);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <AdminLayout>
      <div className="container">
        <CustomMuiDataTable title={"Contact us messages"} data={data} columns={columns} options={options} />

        <Dialog
          fullScreen
          open={visible}
          onClose={handleClose}
          TransitionComponent={Transition}
          style={{zIndex: 2235}}
        >
          <AppBar className="position-relative">
            <Toolbar>
              <button type="button" className="close-modal-button" onClick={handleClose}>
                &times;
              </button>
              <h4 className="text-white mx-3 my-0">Message Details</h4>
            </Toolbar>
          </AppBar>
          <div style={{padding: "25px"}}>
            <div className="row">
              <div className={"col-sm-6"}>
                <label>Full Name :</label>
                <h5>{selectedData.fullName}</h5>
              </div>
              <div className={"col-sm-6"}>
                <label>Email :</label>
                <h5>{selectedData.email}</h5>
              </div>
              <div className={"col-sm-6"}>
                <label>Phone :</label>
                <h5>{selectedData.phone}</h5>
              </div>

              {selectedData.image_name && (
                <div className={"col-sm-12"}>
                  <img src={`${process.env.REACT_APP_FILES_PATH}/contact/${selectedData.image_name}`} />
                </div>
              )}

              <div className={"col-sm-12"}>
                <label>Mesage :</label>
                <h5>{selectedData.message}</h5>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </AdminLayout>
  );
};

export default AdminContactUsMessages;
